import Section from "../section";

export default function TableLoader() {
  return (
    <Section>
      <div class="space-y-4 animate-pulse mt-5">
        <div class="grid grid-cols-4 gap-4 bg-white rounded-lg shadow p-4">
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
        </div>
        <div class="grid grid-cols-4 gap-4 bg-white rounded-lg shadow p-4">
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
        </div>
        <div class="grid grid-cols-4 gap-4 bg-white rounded-lg shadow p-4">
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
        </div>
        <div class="grid grid-cols-4 gap-4 bg-white rounded-lg shadow p-4">
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
          <div class="h-4 bg-gray-300 rounded col-span-1"></div>
        </div>
      </div>
    </Section>
  );
}
